/**
 * projectEvents service — GET /projects/:projectId/events (the COMMS rail feed).
 * Contract: plans/2026-08-27-comms-rail-api-contract.md.
 */
import api from './api';

/**
 * @param {string} projectId
 * @param {object} [opts]
 * @param {number} [opts.limit]           1..100 (server default 30)
 * @param {string} [opts.cursor]          opaque nextCursor from the previous page
 * @param {string|string[]} [opts.workflowUuid]  one uuid or a list (joined by comma)
 * @param {string} [opts.kind]            exact kind match
 * @returns {Promise<{events: Array, nextCursor: string|null, running: {count:number}, needsYou: object}>}
 */
export function listProjectEvents(projectId, { limit, cursor, workflowUuid, kind } = {}) {
  const qs = new URLSearchParams();
  if (Number.isFinite(limit)) qs.set('limit', String(limit));
  if (cursor) qs.set('cursor', cursor);
  const uuids = Array.isArray(workflowUuid) ? workflowUuid.filter(Boolean) : (workflowUuid ? [workflowUuid] : []);
  if (uuids.length) qs.set('workflowUuid', uuids.join(','));
  if (kind) qs.set('kind', kind);
  const q = qs.toString();
  return api.get(`/projects/${encodeURIComponent(projectId)}/events${q ? `?${q}` : ''}`);
}

/**
 * actOnProjectEvent — POST /projects/:projectId/events/:eventId/act.
 * Records a human decision on a NEEDS YOU card.
 *
 * @param {string} projectId
 * @param {string} eventId
 * @param {object} body
 * @param {'answer'|'release'|'take_over'} body.action
 * @param {string} [body.text]   the answer (action = 'answer')
 * @returns {Promise<{ok: boolean, recorded: boolean, ticketKey: string, action: string, event: object}>}
 */
export function actOnProjectEvent(projectId, eventId, { action, text } = {}) {
  const body = { action };
  if (typeof text === 'string') body.text = text;
  return api.post(`/projects/${encodeURIComponent(projectId)}/events/${encodeURIComponent(eventId)}/act`, body);
}

const projectEvents = { listProjectEvents, actOnProjectEvent };
export default projectEvents;
